module.exports = __webpack_public_path__ + "img/am11.fd02a793.jpg";